import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MapsSearchService {

  constructor(public httpClient: HttpClient) { }

  searchPredictions: any = [];
  clickedSearchItem: any;
  googleSearchedPlace: any;
  focusedSearchItemIndex: number = 0;
  noResult = 'No results found for ';
  minSearchQueryLength: number = 3;
  API_URL: string = '';
  placeholder: string = 'Search';

  addCustomSearchListeners() {
    var searchInputElement = document.getElementById('pac-input');
    var dropdownBoxElement = document.getElementById('pac-container');
    var searchIconElement = document.getElementById('pac-input-icon');

    if(searchInputElement) {
      Observable.fromEvent(searchInputElement, 'input')
        .debounceTime(500)
        .subscribe((event: any) => {
          if(dropdownBoxElement) {
            let query = event.target.value;
            if(query.length >= this.minSearchQueryLength) {
              let html = '';
              this.getSearchPredictions(query).subscribe((response: any) => {
                this.searchPredictions = response;
                this.focusedSearchItemIndex = 0;
                this.setSearchDropDownWithPredictions();
              });
            } else {
              this.resetSearchPredictions();
            }
          }
        });
      searchInputElement.addEventListener('keydown', (event) => {
        var keyCode = event.keyCode;
        //Enter
        if(keyCode === 13) {
          this.autoCompleteExecute();
        }
        //Up arrow
        if(keyCode === 38) {
          this.goUpSearchPredictions();
        }
        //Down arrow
        if(keyCode === 40) {
          this.goDownSearchPredictions();
        }
      });
      searchInputElement.addEventListener('focus', () => {
        if((<HTMLInputElement>searchInputElement).value.length >= this.minSearchQueryLength) {
          document.getElementById('pac-container').classList.remove('hidden');
          searchInputElement.classList.add('search-active'); 
           //infoWindow.less
        }
      });
      searchInputElement.addEventListener('blur', () => {
          document.getElementById('pac-container').classList.add('hidden');
          document.getElementById('pac-input').classList.remove('search-active');
      });
    }
    if(searchIconElement) {
      searchIconElement.addEventListener('click', () => {
        this.focusedSearchItemIndex = 0;
        this.autoCompleteExecute();
      });
    }
  }

  getSearchPredictions(query) {
    var currentLocation = {lat : (<any>window).map.getCenter().lat(), lng : (<any>window).map.getCenter().lng()};
    return this.httpClient.get(
      this.API_URL + '/search?query=' + encodeURIComponent(query) +
      '&lat='+ encodeURIComponent(currentLocation.lat) +
      '&lng='+ encodeURIComponent(currentLocation.lng)
    )
    .map((res) => {
      return res;
    });
  }

  autoCompleteExecute(searchItem?) {
    searchItem ? this.searchItemExecute(searchItem) : this.getSearchItemAndExecute();
  }

  getSearchItemAndExecute() {
    let searchInputElement = document.getElementById('pac-input');
    let query = (<HTMLInputElement>searchInputElement).value;
    this.getSearchPredictions(query).subscribe((response: any)=> {
      this.searchPredictions = response;
      this.setSearchDropDownWithPredictions();
      this.searchItemExecute(this.searchPredictions[this.focusedSearchItemIndex]);
    });
  }

  searchItemExecute(searchItem) {
    let w = <any>window;
    this.clickedSearchItem = searchItem;
    if(searchItem && searchItem.placeId && searchItem.source === "GOOGLE") {
      // Create a Place instance and fetch details using the new API
      var place = new w.google.maps.places.Place({
        id: searchItem.placeId
      });
      place.fetchFields({
        fields: ['displayName', 'formattedAddress', 'location', 'viewport', 'addressComponents']
      }).then((result) => {
        this.getPlacesResult()(result.place);
      }).catch((error) => {
        console.error('Error fetching place details:', error);
        this.goToSelectedPoint();
      });
    } else {
      this.goToSelectedPoint();
    }
  }

  getPlacesResult() {
    let w = <any>window;
    return (placeResult) => {
      // Handle the new Places API response format
      // The Place object properties are directly accessible after fetchFields
      if (placeResult && placeResult.location) {
        this.googleSearchedPlace = {
          formatted_address: placeResult.formattedAddress || placeResult.displayName,
          geometry: {
            location: placeResult.location,
            viewport: placeResult.viewport
          },
          address_components: placeResult.addressComponents || []
        };
        this.goToSelectedPoint();
        let input = document.getElementById('pac-input');
        (<HTMLInputElement>input).value = placeResult.formattedAddress || placeResult.displayName;
      }
    }
  }

  goToSelectedPoint() {
    let w = <any>window;
    if(this.clickedSearchItem && this.clickedSearchItem.placeId && this.clickedSearchItem.source === "GOOGLE"){
      w.autoComplete.onSuccess(this.googleSearchedPlace);
    } else if(this.clickedSearchItem && this.clickedSearchItem.propertyId && this.clickedSearchItem.source === "INTERNAL") {
      let input = document.getElementById('pac-input');
      (<HTMLInputElement>input).value = this.clickedSearchItem.name + ', ' + this.clickedSearchItem.addressString;
      let LatLng = {lat : this.clickedSearchItem.point.coordinates[1], lng : this.clickedSearchItem.point.coordinates[0]};
      w.autoComplete.openPropertyQuickView(this.clickedSearchItem, LatLng);
    } else {
      console.log('notification: place not found');
    }
    this.clickedSearchItem = null;
    this.googleSearchedPlace = null;
    this.focusedSearchItemIndex = 0;
    this.resetSearchPredictions();
  }

  setSearchDropDownWithPredictions() {
    let html = '';
    var dropdownBoxElement = document.getElementById('pac-container');
    var searchInputElement = document.getElementById('pac-input');
    searchInputElement.classList.add('search-active'); //infoWindow.less
    if(this.searchPredictions.length > 0) {
      this.searchPredictions.forEach((searchItem) => {
        html += '<div class="search-item">'+ this.encodeForHTML(searchItem.name) +
          (searchItem.source == "INTERNAL"? (', '+ this.encodeForHTML(searchItem.addressString)) :'') +'</div>';
      });
    } else {
        html += '<div class="search-item no-result">'+ this.noResult +''+ this.encodeForHTML((<HTMLInputElement>searchInputElement).value) +'</div>'
    }
    dropdownBoxElement.innerHTML = html;
    dropdownBoxElement.classList.remove('hidden');
    (this.searchPredictions.length > 0)?this.setSearchOptionListenersAndStyle():'';
  }

  encodeForHTML(val) {
    return (<any>window).$ESAPI.encoder().encodeForHTML(val); 
  }

  setSearchOptionListenersAndStyle() {
    let searchItems = document.getElementsByClassName('search-item');
    let w = <any>window;
    this.changeFocusedSearchItemBackgroundColor(searchItems);
    for(let i=0; i < searchItems.length; i++) {
      if (w.PointerEvent) {
        // Add Pointer Event Listener
        searchItems[i].addEventListener('pointerdown', (e:any) => {
          this.autoCompleteExecute(this.searchPredictions[i])
        });
      } else {
        // Add Touch Listener for iPhone and iPad
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !w.MSStream;

        if(!iOS) {
          searchItems[i].addEventListener('mousedown', (e:any) => {
            this.autoCompleteExecute(this.searchPredictions[i])
          });
        } else {
          searchItems[i].addEventListener('touchstart', (e:any) => {
            this.autoCompleteExecute(this.searchPredictions[i])
          });
        }
      }
    }
  }

  goUpSearchPredictions() {
    if(this.focusedSearchItemIndex === 0) {
      this.focusedSearchItemIndex = this.searchPredictions.length - 1;
    } else {
      this.focusedSearchItemIndex--;
    }
    let searchItems = document.getElementsByClassName('search-item');
    (<HTMLElement>searchItems[this.focusedSearchItemIndex ===  this.searchPredictions.length - 1? 0 : this.focusedSearchItemIndex + 1]).classList.remove('focused');
    this.changeFocusedSearchItemBackgroundColor(searchItems);
  }

  goDownSearchPredictions() {
    if(this.focusedSearchItemIndex === this.searchPredictions.length - 1) {
      this.focusedSearchItemIndex = 0;
    } else {
      this.focusedSearchItemIndex++;
    }
    let searchItems = document.getElementsByClassName('search-item');
    (<HTMLElement>searchItems[this.focusedSearchItemIndex ===  0 ? this.searchPredictions.length - 1 : this.focusedSearchItemIndex - 1]).classList.remove('focused');
    this.changeFocusedSearchItemBackgroundColor(searchItems);
  }

  changeFocusedSearchItemBackgroundColor(searchItems) {
    (<HTMLElement>searchItems[this.focusedSearchItemIndex]).classList.add('focused');
  }

  changeSearchInputValue() {
    let input = document.getElementById('pac-input');
    (<HTMLInputElement>input).value = this.searchPredictions[this.focusedSearchItemIndex].name +
        (this.searchPredictions[this.focusedSearchItemIndex].source == "INTERNAL"? (', '+this.searchPredictions[this.focusedSearchItemIndex].addressString):'');
  }

  resetSearchPredictions() {
    var dropdownBoxElement = document.getElementById('pac-container');
    this.searchPredictions = [];
    dropdownBoxElement.innerHTML = '';
    dropdownBoxElement.classList.add('hidden');
    var searchInputElement = document.getElementById('pac-input');
    if(searchInputElement.classList.contains('search-active')){
      searchInputElement.classList.remove('search-active');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/maps-search/maps-search.service.ts